module.exports = __webpack_public_path__ + "img/resized-cover7.2c05b86d.png";